import { Link, Stack, Typography } from '@presov.sk/presov-ui-react';
import React from 'react';

type Props = {
  text: string;
};

const detectUrls = (text: string) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part, index) => {
    if (urlRegex.test(part)) {
      return (
        <Link key={index} href={part} target='_blank' rel='noopener noreferrer'>
          {part}
        </Link>
      );
    }
    return part;
  });
};

export const FormattedText: React.FC<Props> = ({ text }) => {
  return (
    <Stack spacing={0.5}>
      {text.split('\n').map((line, i) => (
        <Typography key={i} variant='body2' sx={{ wordBreak: 'break-word' }}>
          {detectUrls(line)}
        </Typography>
      ))}
    </Stack>
  );
};
